/**
 * Profile utilities for AI Toolkit integration
 * Handles conversion from NextAuth session to AI Toolkit profile format
 */
import type { Profile } from "@zapier/ai-toolkit";

import type { Session } from "next-auth";

/**
 * Creates a Profile object from NextAuth session
 * @param session - NextAuth session object
 * @returns Profile object compatible with AI Toolkit
 */
export function createProfileFromSession(
  session: Session | null | undefined,
): Profile {
  if (!session?.user) {
    return { is_logged_in: false };
  }

  const user = session.user;

  if (user.is_logged_in === false) {
    return { is_logged_in: false };
  }

  const userId =
    typeof user.id === "string" ? parseInt(user.id, 10) : Number(user.id);
  if (isNaN(userId)) {
    return { is_logged_in: false };
  }

  const accountId =
    typeof session.currentAccountId === "number"
      ? session.currentAccountId
      : userId;

  return {
    is_logged_in: true,
    id: userId,
    current_account_id: accountId,
    is_staff: Boolean(user.is_staff),
    email: user.email,
    signup: user.created_at,
    plan_type: null,
  } as Profile;
}
